/* eslint-disable max-len */
import 'react';

function DocWordCloseSvg(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_30061_14230" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                <rect width="16" height="16" fill="white" />
            </mask>
            <g mask="url(#mask0_30061_14230)">
                <path d="M12.6667 3.33337L3.33335 12.6667" stroke="white" strokeLinecap="round" />
                <path d="M3.33331 3.33337L12.6666 12.6667" stroke="white" strokeLinecap="round" />
            </g>
        </svg>

    );
}

export default DocWordCloseSvg;
